export default "__VITE_ASSET__CZb_BDbk__"